import { Card } from "primereact/card";
import React from "react";

export default function HostingServices({ hosting, formatDate }) {
  return (
    <div>
      {hosting?.length ? (
        <Card
          style={{ minWidth: "15rem" }}
          className="d-flex w-min-320  h-auto w-auto text-center"
          title="Hostinglerim"
        >
          {hosting &&
            hosting.map((host, index) => {
              const currentDate = new Date();
              const renewalDate = new Date(host?.renewal_date);
              const timeDifference =
                renewalDate.getTime() - currentDate.getTime();
              const daysRemaining = Math.ceil(
                timeDifference / (1000 * 60 * 60 * 24)
              );

              return (
                <div className="flex flex-column" key={index}>
                  <div className="flex text-left align-items-center text-gray h-auto justify-content-start  p-2 h-auto bg-cyan-100	 font-bold border-round m-2">
                    <div className="w-100">
                      <div className="d-flex justify-content-between">
                        <span>Alan Adı:</span>
                        <span>{host?.domain_name}</span>
                      </div>
                      <div className="d-flex justify-content-between">
                        <span>Platform:</span>
                        <span>{host?.platform}</span>
                      </div>
                      <div className="d-flex justify-content-between">
                        <span>Yöneten:</span>
                        <span>{host?.owner}</span>
                      </div>
                      <div className="d-flex justify-content-between">
                        <span>Kayıt:</span>
                        <span>{formatDate(host?.starting_date)}</span>
                      </div>
                      <div className="d-flex justify-content-between">
                        <span>Bitiş:</span>
                        <span>{formatDate(host?.renewal_date)}</span>
                      </div>
                      <div className="d-flex justify-content-between">
                        <span>Kalan Süre:</span>
                        <span>{daysRemaining} gün</span>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
        </Card>
      ) : null}
    </div>
  );
}
